import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";

@Component({
  selector: "app-search-form-jica",
  templateUrl: "./search-form-jica.component.html",
  styleUrls: ["./search-form-jica.component.css"],
})
export class SearchFormJicaComponent implements OnInit {
  // --- 基本データ ---
  @Input() search: any = { upload_maintenance_list: [] };
  @Input() search_item: any = {};
  @Input() hiro_list: any = {};
  @Input() datalist: any[] = [];
  @Input() selectedUpload: any[] = [];
  @Input() usersService: any;
  @Input() commonService: any;

  // --- 制御フラグ ---
  @Input() mendan_flg: number = 0;
  @Input() upload_flg: number = 0;
  @Input() upload_required_flg: number = 0;
  @Input() displayMonths: number = 2;

  // --- 検索条件（双方向バインド用） ---
  @Input() inputCode: any;
  @Output() inputCodeChange = new EventEmitter<any>();
  @Input() inputName: any;
  @Output() inputNameChange = new EventEmitter<any>();
  @Input() inputCompany: any;
  @Output() inputCompanyChange = new EventEmitter<any>();
  @Input() inputSyozoku: any;
  @Output() inputSyozokuChange = new EventEmitter<any>();
  @Input() inputHiro: any;
  @Output() inputHiroChange = new EventEmitter<any>();
  @Input() inputSuimin: any;
  @Output() inputSuiminChange = new EventEmitter<any>();
  @Input() inputInterviewer: any;
  @Output() inputInterviewerChange = new EventEmitter<any>();

  @Input() SJIScheck: boolean = false;
  @Output() SJIScheckChange = new EventEmitter<boolean>();

  @Input() search_answer_mode: boolean = false;
  @Output() search_answer_modeChange = new EventEmitter<boolean>();

  @Input() examination_target_flg: boolean = false;
  @Output() examination_target_flgChange = new EventEmitter<boolean>();

  @Input() reinspectionUnuploadedFlg: boolean = false;
  @Output() reinspectionUnuploadedFlgChange = new EventEmitter<boolean>();

  // --- イベント通知 ---
  @Output() onSearch = new EventEmitter<number>();
  @Output() onCsvExport = new EventEmitter<void>();
  @Output() onCategoryCsv = new EventEmitter<any>();
  @Output() onSpecificCsv = new EventEmitter<any>();
  @Output() onOrganicCsv = new EventEmitter<any>();
  @Output() onYoyakuCsv = new EventEmitter<any>();
  @Output() onMendanYoyakuCsv = new EventEmitter<any>();
  @Output() onYoyakuDateSearch = new EventEmitter<number>();
  @Output() onAnswerSearch = new EventEmitter<any>();
  @Output() onAnalysis = new EventEmitter<any>();
  @Output() onGoPerson = new EventEmitter<any>();
  @Output() onYoyakuhyoLink = new EventEmitter<any>();
  @Output() onSelectUM = new EventEmitter<any>();
  @Output() upload_required_flgChange = new EventEmitter<number>();

  constructor() {}
  ngOnInit() {}

  // 相互排他用のロジック：アップロード項目のいずれかがチェックされているか
  isAnyUploadSelected(): boolean {
    if (!this.search || !this.search.upload_maintenance_list) return false;
    return this.search.upload_maintenance_list.some((f: any) => f.checked);
  }

  // 必須未アップロードの変更通知
  onUploadRequiredChange(val: boolean) {
    const numVal = val ? 1 : 0;
    this.upload_required_flgChange.emit(numVal);
  }

  toggleDate(picker: any) {
    picker.toggle();
  }

  cateCheckChangeYoyaku(cate: any) {
    cate.cate_check = !cate.cate_check;
    if (cate.yoyakustatuslist) {
      cate.yoyakustatuslist.forEach((s) => (s.status_check = cate.cate_check));
    }
  }

  cateCheckChange(cate: any) {
    cate.cate_check = !cate.cate_check;
    if (cate.answerstatuslist) {
      cate.answerstatuslist.forEach((s) => (s.status_check = cate.cate_check));
    }
  }

  checkCategoryChecked(cate: any): boolean {
    if (!cate.answerstatuslist) return true;
    return !cate.answerstatuslist.some((s) => s.status_check);
  }

  checkYoyakuChecked(cate: any): boolean {
    if (!cate.yoyakustatuslist) return true;
    return !cate.yoyakustatuslist.some((s) => s.status_check);
  }
}



// WEBPACK FOOTER //
// ./src/app/a0108-person/search-form/jica/search-form-jica.component.ts